import type { TemplateLayout } from '@/types/template';

const CAPTION_Y_LIFT = 100 / 1920;

export const TEMPLATE_LAYOUTS: Record<string, TemplateLayout> = {
    basic: {
        id: 'basic',
        name: 'Basic',
        content: {
            x: 0,
            y: 0,
            width: 1080,
            height: 1920,
            scale: 1,
            objectFit: 'cover'
        },
        caption: {
            position: 'bottom',
            x: 0,
            y: 0.82 - CAPTION_Y_LIFT,
            width: 1080, // Default for 9:16, generator will override for 16:9
            height: 220  // Default for 9:16, generator will override for 16:9
        }
    },
    ssul: {
        id: 'ssul',
        name: 'Ssul (썰)',
        content: {
            x: 0,
            y: 205, // Adjusted from 183 based on user input
            width: 990, // Adjusted from 960 based on user input
            height: 867, // Adjusted from 842 based on user input
            scale: 1,
            objectFit: 'cover'
        },
        caption: {
            position: 'top',
            x: 0,
            y: -414, // Adjusted from -41
            width: 1080,
            height: 180
        },
        title: {
            isDoubleLine: true,
            position: 'top',
            x: 0,
            y: -850, // Adjusted from -870 study
            width: 1080,
            height: 180, // Increased to prevent clipping
            secondaryX: 0,
            secondaryY: -672, // Adjusted from -590 (maintains spacing)
            secondaryWidth: 1080,
            secondaryHeight: 180 // Increased to prevent clipping
        }
    },
    issue_classic: {
        id: 'issue_classic',
        name: '정석 이슈 (풀 와이드)',
        content: {
            x: 0,
            y: 40, // 타이틀 바로 아래로 상향 조정 (기존 -40에서 80px 내림)
            width: 1080,
            height: 1050,
            scale: 1,
            objectFit: 'cover'
        },
        caption: {
            position: 'bottom',
            x: 0,
            y: 0.82 - CAPTION_Y_LIFT,
            width: 1080,
            height: 180
        },
        title: {
            isDoubleLine: true,
            position: 'top',
            x: 0,
            y: -790, // Slightly moved down
            width: 1080,
            height: 180, // Increased to prevent clipping
            secondaryX: 0,
            secondaryY: -590, // 간격 확보를 위해 더 내림 (200차이)
            secondaryWidth: 1080,
            secondaryHeight: 180 // Increased to prevent clipping
        }
    }
};

export function getLayoutById(layoutId: string): TemplateLayout | undefined {
    return TEMPLATE_LAYOUTS[layoutId];
}

export function getAllLayouts(): TemplateLayout[] {
    return Object.values(TEMPLATE_LAYOUTS);
}
